import { render, staticRenderFns } from "./DownloadOrGoToDynamicTable.vue?vue&type=template&id=40db32f3&scoped=true&"
import script from "./DownloadOrGoToDynamicTable.vue?vue&type=script&lang=js&"
export * from "./DownloadOrGoToDynamicTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40db32f3",
  null
  
)

export default component.exports